import { render, staticRenderFns } from "./CustomerCustomerCategory.vue?vue&type=template&id=5b1074ae&scoped=true"
import script from "./CustomerCustomerCategory.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerCategory.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomerCategory.vue?vue&type=style&index=0&id=5b1074ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1074ae",
  null
  
)

export default component.exports